/**
 * Whether a company's stored `logo` is an actual image the app can render.
 *
 * `companies.logo` is a free-text column, so a non-empty value does NOT mean a logo was
 * uploaded — seed and imported rows carry descriptive placeholders like "Louis Vuitton Logo".
 * Requesting one of those as an image is worse than it sounds: the SPA answers unknown paths
 * with index.html at 200, so the placeholder "loads" as a broken image rather than failing
 * and falling back to initials.
 *
 * Extracted from `CompanyAvatar`, which had this test inline, when the VRG-340 setup checklist
 * became the second caller (§36 — extract on the second hand-roll). The two disagreeing is
 * exactly the bug it was extracted to prevent: the checklist ticked "Add your logo" for a brand
 * whose avatar was, correctly, still rendering initials.
 */
export const hasCompanyLogo = (logo?: string | null): boolean =>
  Boolean(logo && /^(https?:\/\/|\/|data:)/.test(logo))

/** The logo URL to render, or `undefined` when the stored value is not a usable image. */
export const companyLogoSrc = (logo?: string | null): string | undefined =>
  hasCompanyLogo(logo) ? (logo as string) : undefined
